import { css } from '@emotion/react';
import { Box, styled } from '@mui/material';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { HeaderWrapper } from '@/components/HeaderWrapper';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';

export const Route = createFileRoute('/_public/_legal')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: LegalLayout,
});

const Root = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
);

const LegalWrapper = styled(Box)(
  ({ theme }) => css`
    padding: ${theme.spacing(4)} ${theme.spacing(3)} ${theme.spacing(12)};

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      padding: ${theme.spacing(6)} ${theme.spacing(12)};
    }
  `,
);

const FooterWrapper = styled(Box)(
  ({ theme }) => css`
    margin-top: auto;
    padding-bottom: ${theme.spacing(2)};
    display: none;

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      display: inherit;
      padding: 0;
    }
  `,
);

function LegalLayout() {
  return (
    <Root>
      <HeaderWrapper>
        <Header />
      </HeaderWrapper>
      <LegalWrapper>
        <Outlet />
      </LegalWrapper>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </Root>
  );
}
